import axios from "axios";
import { storage } from "./";
import apiClient from "./apiClient";

export const LOCAL_STORAGE_KEY_AUTH_TOKEN = "authToken";

const begUrl = "https://api2.hooverandstrong.com/api/";
const strapiUrl = "https://cms.hooverandstrong.com/api";
const strapiKey = process.env.REACT_APP_STRAPI_AUTH;

function userToken() {
  return storage.getStorageItem(LOCAL_STORAGE_KEY_AUTH_TOKEN);
}

function Headers() {
  const token = userToken();
  return {
    Accept: "application/json",
    Authorization: token,
    "Content-Type": "application/json",
  };
}

function commonHeaders() {
  const token = userToken();
  if (token) {
    return {
      Accept: "application/json",
      Authorization: token,
    };
  } else {
    return {
      Accept: "application/json",
    };
  }
}

function strapiHeaders() {
  return {
    Accept: "application/json",
    Authorization: `bearer ${strapiKey}`,
    "Content-Type": "application/json",
  };
}

function uploadHeaders() {
  return {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  };
}

const headers = () =>
  Object.assign(commonHeaders(), { "Content-Type": "application/json" });

const isPrivilegedRoute = (url) => {
  return url.match(/\/api\/history/);
};

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      if (
        window.location.pathname === "/login" ||
        isPrivilegedRoute(error.request.responseURL)
      ) {
        return Promise.reject(error);
      } else {
        storage.removeStorageItem("authToken");
        storage.removeStorageItem("currentUser");
        storage.removeStorageItem("sessionExpiry");
        storage.clearSessionStorage();
        setTimeout(function () {
          window.location.reload(true);
        }, 300);
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

const post = (url, data) => {
  return axios({
    method: "post",
    url: `${begUrl}${url}`,
    data: data,
    timeout: 600000,
    headers: Headers(),
  });
};

const get = (url, id) => {
  if (id) {
    return axios.get(`${begUrl}${url}${id}`, {
      headers: headers(),
    });
  } else {
    return axios.get(`${begUrl}${url}`, {
      headers: headers(),
    });
  }
};

const getStrapi = (url, id) => {
  if (id) {
    return axios.get(`${strapiUrl}${url}${id}`, {
      headers: strapiHeaders(),
    });
  } else {
    return axios.get(`${strapiUrl}${url}`, {
      headers: strapiHeaders(),
    });
  }
};

const pdfDownload = (url, data) => {
  return axios({
    method: "post",
    url: `${begUrl}${url}`,
    data: data,
    timeout: 600000,
    headers: headers(),
    responseType: "blob",
  });
};

const invoiceDownload = (url) => {
  return axios({
    method: "get",
    url: `${begUrl}${url}`,
    timeout: 600000,
    headers: headers(),
    responseType: "blob",
  });
};

const upload = (url, data) => {
  return axios({
    method: "post",
    url: `${begUrl}${url}`,
    data: data,
    timeout: 600000,
    headers: uploadHeaders(),
  });
};

export const postRequest = (endpoint, data) => {
  return apiClient.post(endpoint, data);
};

export const getRequest = (endpoint, params = {}) => {
  return apiClient.get(endpoint, { params });
};

export const deleteRequest = (endpoint, params = {}) => {
  return apiClient.delete(endpoint, { params });
};

const api = {
  userToken: userToken,
  fetch: get,
  post: post,
  fetchStrapi: getStrapi,
  pdfDownload: pdfDownload,
  invoiceDownload: invoiceDownload,
  upload: upload,
  postRequest: postRequest,
  getRequest: getRequest,
  deleteRequest: deleteRequest,
};

export default api;
